import { useCmsContext } from '../../contexts/cms'

export const useLabelsAndInternationalization = () => {
  const { cmsData } = useCmsContext()

  return cmsData['common-elements']['labels-and-internationalization']
}
